/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedForceSearchLink_itemSearch = {
    readonly pageType: string | null;
    readonly searchTerm: string | null;
    readonly searchCorrections: {
        readonly forceSearchUri: string | null;
        readonly originalSearchTerm: string | null;
        readonly semanticSearchTerm: string | null;
        readonly classificationSearchTerm: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedSearchSuggestions_itemSearch">;
    readonly " $refType": "SbSharedForceSearchLink_itemSearch";
};
export type SbSharedForceSearchLink_itemSearch$data = SbSharedForceSearchLink_itemSearch;
export type SbSharedForceSearchLink_itemSearch$key = {
    readonly " $data"?: SbSharedForceSearchLink_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedForceSearchLink_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedForceSearchLink_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "kind": "LinkedField",
      "name": "searchCorrections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forceSearchUri",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalSearchTerm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "semanticSearchTerm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "classificationSearchTerm",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '0a1091f51c79afafcd5ded9fc1f26c4e';
export default node;
